import { render, staticRenderFns } from "./VuetifyMultipleAutocomplete.vue?vue&type=template&id=976e1aa2"
import script from "./VuetifyMultipleAutocomplete.vue?vue&type=script&lang=js"
export * from "./VuetifyMultipleAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports